module.exports = __webpack_public_path__ + "media/images/marketing_mobile_image-54549fdc73452bf1dd5db72de7e917d7.svg";